(function() {
  var HOVER_CLOSE_DELAY = 180; // ms para evitar parpadeo al salir

  function setViewportHeight(root) {
    var viewport = root.querySelector('.menu-slider__viewport');
    if (!viewport) return;
    var state = viewport.getAttribute('data-state') || 'level1';
    var panel = viewport.querySelector(
      state === 'level2' ? '.menu-slider__panel--level2' : '.menu-slider__panel--level1'
    );
    if (panel) viewport.style.height = panel.scrollHeight + 'px';
  }

  function openDropdown(root) {
    var trigger  = root.querySelector('[data-slider-trigger]');
    var viewport = root.querySelector('.menu-slider__viewport');
    if (!viewport) return;
    trigger && trigger.setAttribute('aria-expanded', 'true');
    root.setAttribute('data-open', 'true');
    viewport.hidden = false;
    setViewportHeight(root);
  }

  function closeDropdown(root) {
    var trigger  = root.querySelector('[data-slider-trigger]');
    var viewport = root.querySelector('.menu-slider__viewport');
    if (!viewport) return;
    trigger && trigger.setAttribute('aria-expanded', 'false');
    root.setAttribute('data-open', 'false');
    viewport.setAttribute('data-state', 'level1');
    viewport.hidden = true;
    viewport.style.height = '';
    var level2Panel = root.querySelector('.menu-slider__panel--level2');
    level2Panel && level2Panel.setAttribute('aria-hidden', 'true');
  }

  function init(root) {
    if (!root || root.__menuSliderReady) return;
    root.__menuSliderReady = true;

    var viewport    = root.querySelector('.menu-slider__viewport');
    var level2Panel = root.querySelector('.menu-slider__panel--level2');
    var level2List  = root.querySelector('.menu-slider__list--level2');
    var level2Title = root.querySelector('.menu-slider__title');
    var trigger     = root.querySelector('[data-slider-trigger]');
    var hoverTimer  = null;

    // Toggle por CLICK (sigue igual)
    if (trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        expanded ? closeDropdown(root) : openDropdown(root);
      });
    }

    // === HOVER (solo desktop / pointer fino) ===
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (supportsHover && trigger) {
      // Abrir al entrar al trigger
      trigger.addEventListener('mouseenter', function() {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
        openDropdown(root);
      });

      // Si entras al contenedor, cancela cierre
      root.addEventListener('mouseenter', function() {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      });

      // Cerrar cuando sales del <li> completo (con delay anti-parpadeo)
      root.addEventListener('mouseleave', function() {
        if (hoverTimer) clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function() {
          closeDropdown(root);
          hoverTimer = null;
        }, HOVER_CLOSE_DELAY);
      });

      // Si entras al viewport, también cancela cierre
      viewport && viewport.addEventListener('mouseenter', function() {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      });
    }

    // Delegación interna (abrir subnivel / volver)
    root.addEventListener('click', function(e) {
      var openTrigger = e.target.closest('[data-open-sub]');
      if (openTrigger && root.contains(openTrigger)) {
        var li = openTrigger.closest('.menu-slider__item.has-children');
        if (!li) return;
        var idx = li.getAttribute('data-parent-index');

        var parentLink = li.querySelector('.menu-slider__link');
        if (level2Title) level2Title.textContent = (parentLink && parentLink.textContent.trim()) || '';

        var hiddenList = root.querySelector('.menu-slider__children[data-parent-index="'+ idx +'"]');
        if (level2List) level2List.innerHTML = hiddenList ? hiddenList.innerHTML : '';

        e.preventDefault();
        e.stopPropagation();

        viewport && viewport.setAttribute('data-state', 'level2');
        level2Panel && level2Panel.setAttribute('aria-hidden', 'false');
        setViewportHeight(root);
        return;
      }

      var back = e.target.closest('.menu-slider__back');
      if (back && root.contains(back)) {
        e.preventDefault();
        e.stopPropagation();
        viewport && viewport.setAttribute('data-state', 'level1');
        level2Panel && level2Panel.setAttribute('aria-hidden', 'true');
        setViewportHeight(root);
      }
    });

    // Recalcular al redimensionar
    window.addEventListener('resize', function() {
      if (root.getAttribute('data-open') === 'true') setViewportHeight(root);
    });

    // Cerrar con click fuera
    document.addEventListener('click', function onDocClick(ev) {
      if (!root.isConnected) { document.removeEventListener('click', onDocClick); return; }
      var inside = ev.target.closest('.t4s-menu-slider[data-role="slider"]') === root;
      var open = root.getAttribute('data-open') === 'true';
      if (open && !inside) closeDropdown(root);
    });
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('.t4s-menu-slider[data-role="slider"]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function() { initAll(); });
  document.addEventListener('shopify:section:load', function(evt) { initAll(evt.target); });
})();


//MENU MOBILE
(function(){
  "use strict";

  function closePanel(panel){
    if(!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('data-msmb-hidden','true');
  }

  function openPanel(panel){
    if(!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('data-msmb-hidden','false');
  }

  function initMsmb(root){
    if (!root || root.__msmbReady) return;
    root.__msmbReady = true;

    const blockId = root.id || '(sin-id)';

    function onClick(e){
      // Toggle del título (abre nivel 0 SIEMPRE que haya menú)
      const toggle = e.target.closest('[data-msmb-toggle]');
      if (toggle && root.contains(toggle)) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();

        // Cierra otros paneles abiertos en otros bloques
        document.querySelectorAll('.msmb .msmb-panel.is-open').forEach((p)=>{
          if (!root.contains(p)) closePanel(p);
        });

        const rootPanel = root.querySelector('.msmb-panel[data-msmb-depth="0"]');
        if (!rootPanel) { console.warn('[msmb] No encontré panel depth 0 en', blockId); return; }
        openPanel(rootPanel);

        // Foco opcional en el botón back
        rootPanel.querySelector('[data-msmb-back]')?.focus?.();

        console.debug('[msmb] toggle clic en bloque', blockId, '→ open depth 0');
        return;
      }

      // Abrir subpanel (nivel 1/2)
      const openBtn = e.target.closest('[data-msmb-open]');
      if (openBtn && root.contains(openBtn)) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();

        // (Opcional) cierra subpaneles abiertos dentro de este bloque antes de abrir
        root.querySelectorAll('.msmb-panel.is-open').forEach((p)=>{
          // deja abierto depth 0 si prefieres; si quieres cerrar todo, no filtres
          if (p.getAttribute('data-msmb-depth') !== '0') closePanel(p);
        });

        const panel = openBtn.nextElementSibling; // UL .msmb-panel contiguo
        if (panel && panel.classList.contains('msmb-panel')) {
          openPanel(panel);
          console.debug('[msmb] open subpanel en', blockId, '→ depth', panel.getAttribute('data-msmb-depth'));
        } else {
          console.warn('[msmb] Link con hijos sin UL .msmb-panel contiguo en', blockId);
        }
        return;
      }

      // Botón Atrás
      const backBtn = e.target.closest('[data-msmb-back]');
      if (backBtn && root.contains(backBtn)) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();

        const currentPanel = backBtn.closest('.msmb-panel');
        if (currentPanel) {
          closePanel(currentPanel);

          // Devuelve foco al link padre si existe
          const parentLink = currentPanel.parentElement?.querySelector('> .msmb-link');
          parentLink?.focus?.();

          console.debug('[msmb] back en', blockId, '→ close depth', currentPanel.getAttribute('data-msmb-depth'));
        }
        return;
      }
    }

    // Listener en CAPTURA para ganarle a scripts del theme
    root.addEventListener('click', onClick, true);

    // Accesibilidad teclado
    root.addEventListener('keydown', function(e){
      const isActivateKey = (e.key === 'Enter' || e.key === ' ');
      if (!isActivateKey) return;
      const tgt = e.target;
      if (tgt.matches('[data-msmb-toggle], [data-msmb-open], [data-msmb-back]')) {
        e.preventDefault();
        tgt.click();
      }
    }, true);

    console.debug('[msmb] init OK:', blockId);
  }

  function initAll(){
    document.querySelectorAll('[data-msmb-root]').forEach(initMsmb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init cuando Shopify recarga secciones
  document.addEventListener('shopify:section:load', initAll);

  // (Opcional) si el theme inyecta HTML dinámico
  const mo = new MutationObserver(()=>initAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


